import { useContext } from 'react'

import { UserDetailsContext } from 'src/context/userDetailsContext'

/**
 * Extract timezone and its abbreviation from UserDetailsContext
 * @returns {[string?,string?]} timezone, timezoneAbbr
 */
export function useTimezone() {
    const {
        userDetails: {
            organization: {
                timezone: { abbr, utc: timezone },
            },
        },
    } = useContext(UserDetailsContext)

    return [timezone ?? 'UTC', abbr ?? 'UTC']
}
